<template>
	<ActivityDetailSection :title="t('activityPage.details.relatedTarget')">
		<ActivityDetailState
			:loading="loading"
			:error="loadError"
			:empty="!target && !targetId"
			:loading-message="t('activityPage.details.loadingTarget')"
			:error-message="t('activityPage.details.loadTargetError')"
			:empty-message="t('activityPage.details.emptyTarget')"
		>
			<ActivityResourceCard v-if="target || targetId" class="target-card">
				<OpportunityCardFlagIcon class="target-icon" :type="target?.type ?? OpportunityType.OpportunityTarget" />
				<strong>{{ target?.address?.trim() || target?.city?.trim() || t("unknownAddress") }}</strong>
				<ActivityMapButton :to="targetRoute" />
			</ActivityResourceCard>
		</ActivityDetailState>
	</ActivityDetailSection>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import ActivityDetailSection from "@/components/activity/ActivityDetailSection.vue"
import ActivityDetailState from "@/components/activity/ActivityDetailState.vue"
import ActivityMapButton from "@/components/activity/ActivityMapButton.vue"
import ActivityResourceCard from "@/components/activity/ActivityResourceCard.vue"
import OpportunityCardFlagIcon from "@/components/opportunities/OpportunityCardFlagIcon.vue"
import { OpportunityType, type Opportunity } from "@/model/DataModel"

const props = withDefaults(
	defineProps<{
		target: Opportunity | null
		targetId?: string | null
		projectId: string | null
		loading?: boolean
		loadError?: boolean
	}>(),
	{
		targetId: null,
		loading: false,
		loadError: false,
	}
)

const { t } = useI18n()

const targetRoute = computed(() => ({
	path: "/",
	query: {
		project: props.projectId ?? undefined,
		opp: props.target?.id ?? props.targetId ?? undefined,
	},
}))
</script>

<style scoped>
.target-card {
	> strong {
		flex: 1;
		min-width: 0;
		overflow: hidden;
		color: var(--neutral-900);
		font-size: var(--font-size-regular);
		font-weight: var(--font-weight-semibold);
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}

.target-icon {
	flex: 0 0 auto;
}
</style>
